/**
 * defa.collections.pickupTimes
 * A Collection of PickupTimes
 * @version 1.2.0
 */
import PickupTime from 'scripts/defa/control/pickup-times/model-pickuptime';

const PickupTimes = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : PickupTime,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

} );


export default PickupTimes